import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-star_fill",
  "use": "rt-portal-star_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-star_fill\"><defs><style type=\"text/css\"></style></defs><path d=\"M905.5 364.1l-225-33.2c-6.3 0-11.1-3.2-12.7-7.9l-98.2-203.8c-6.3-12.6-15.8-22.1-28.5-28.4-31.7-15.8-69.7-3.2-85.6 28.4l-99.8 202.2c-3.2 3.2-7.9 7.9-12.7 7.9l-225 33.2c-14.3 3.2-26.9 9.5-36.4 19-23.8 25.3-23.8 66.4 1.6 90.1l160 158c3.2 3.2 6.3 9.5 4.8 14.2l-38 222.8c-3.2 12.6 0 26.9 6.3 39.5 15.8 31.6 53.9 42.7 85.6 26.9l201.2-106c4.8-1.6 11.1-1.6 15.8 0l201.2 105.8c11.1 6.3 25.4 7.9 39.6 6.3 34.9-6.3 58.6-37.9 52.3-72.7l-38-222.8c0-4.7 1.6-11.1 4.8-14.2l161.6-158c11.1-9.5 17.4-22.1 19-36.3 4.7-34.6-19-66.2-53.9-71z\" p-id=\"3361\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/star_fill.svg
// module id = 1890
// module chunks = 137